import React from 'react'

import classnames from 'classnames'

import { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { RecipeAttribute } from './RecipeAttribute'
import { useAttributes } from './useAttributes'

import css from './AttributeGrid.css'

type AttributeGridProps = {
  maxNoAttributes?: number
  recipe: MenuRecipe
  loading?: boolean
}

const LoadingSkeleton = ({ style }: { style?: React.CSSProperties }) => (
  <span className={css.loadingSkeleton} style={style} data-testid="LoadingSkeleton" />
)

export const AttributeGrid = ({ maxNoAttributes = 20, recipe, loading }: AttributeGridProps) => {
  const attributes = useAttributes({ maxNoAttributes, recipe })

  if (loading) {
    return (
      <div className={classnames(css.attributes)}>
        {[...Array(4)].map(() => (
          <LoadingSkeleton key={Math.random()} style={{ height: '10px', marginBottom: '10px' }} />
        ))}
      </div>
    )
  }

  if (attributes.length === 0) {
    return null
  }

  return (
    <div className={classnames(css.attributes)} data-testid="RecipeAttribute">
      {attributes.map(({ name, value, icon }) => (
        <RecipeAttribute key={name} name={name} value={value} icon={icon} />
      ))}
    </div>
  )
}
